

<app-shared [type]="'bon-transfert'" [status]="'broullion'"></app-shared>
